"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _every = _interopRequireDefault(require("lodash/every"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _TableContext = require("./internal/TableContext");
/**
 * A utility function to set selected row ids, based on the events produced by the
 * `onRowSelectionChange` callback. It operates on a given set of `selectedRowIds`,
 * adding/removing ids according to the particulars of the event.
 * * Passing in objects for the data: disabled rows are never selected
 * * Passing in ids for the data: do not include ids for disabled rows
 *
 * @param {object} selectionEvent                      The event sent to the `onRowSelectionChange` function
 * @param {Array.<string>} selectedRowIds              The current set of selected row ids
 * @param {Array.<string> | Array.<object>} allRowData A list of all possible row ids or table data. Passing all ids is deprecated. Pass table data instead.
 * @return {Array.<string>}                            The updated list of selected ids
 */
var _default = exports.default = function _default(selectionEvent, selectedRowIds, allRowData) {
  // TODO: Remove the array validation logic after we remove support for all IDs.
  var arrayType = (0, _every.default)(allRowData, _isString.default) && 'string' || (0, _every.default)(allRowData, _isObject.default) && 'object';
  if (!arrayType) {
    console.error('The `data` array should be of either type string or object');
    return null;
  }
  var rowIds;
  var allIds = arrayType === 'object' ? allRowData.filter(function (d) {
    return d.rowSelectionDisabled !== true;
  }).map(function (d) {
    return d.id;
  }) : allRowData;
  switch (selectionEvent.selectionType) {
    case _TableContext.TableProvider.ROW_SELECTION_ALL:
      {
        rowIds = [].concat(allIds);
        break;
      }
    case _TableContext.TableProvider.ROW_SELECTION_NONE:
      {
        rowIds = [];
        break;
      }
    case _TableContext.TableProvider.ROW_SELECTION_SELECTED:
      {
        if (selectedRowIds.indexOf(selectionEvent.rowId) === -1) {
          rowIds = [].concat(selectedRowIds);
          rowIds.push(selectionEvent.rowId);
        }
        break;
      }
    case _TableContext.TableProvider.ROW_SELECTION_UNSELECTED:
      {
        var index = selectedRowIds.indexOf(selectionEvent.rowId);
        if (index !== -1) {
          rowIds = [].concat(selectedRowIds);
          rowIds.splice(index, 1);
        }
        break;
      }
    default:
      {
        console.warn("getSelectedRowIds: invalid selectionType: " + selectionEvent.selectionType);
        break;
      }
  }
  return rowIds;
};